import { z, ZodIssueCode } from "zod";


export const SaldoBancarioCadastroSchema = z.object({
    idBancoPagamento: z.coerce.number().nonnegative(),
    idBancoTransferencia: z.coerce.number().optional(),
    tipo: z.coerce.boolean(),
    valor: z.coerce.number().optional().nullable(),
    dataTransferencia: z.coerce.date().optional().nullable(),
    cadastroMovimento: z.coerce.boolean().default(false),
}).superRefine((data, ctx) => {
    if (!data.cadastroMovimento) {
        if (data.idBancoTransferencia === undefined || data.idBancoTransferencia < 0) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: 'Este campo deve ser preenchido!',
                path: ['idBancoTransferencia'],
            });
        }
    }
});

export type SaldoBancarioCadastroForm = z.infer<typeof SaldoBancarioCadastroSchema>;

export const defaultSaldoBancarioCadastroForm: Partial<SaldoBancarioCadastroForm> = {

}